// extracted by mini-css-extract-plugin
export default {"ClientDetail":"TaskList_ClientDetail__Zz9Ek","tableResponsive":"TaskList_tableResponsive__uMz5P"};